module.exports = __webpack_public_path__ + "img/wp-hosting.4c14f9af.svg";